// extracted by mini-css-extract-plugin
export var avatarContainer = "_bf-0";
export var avatarTypingWave = "_bf-i";
export var gray = "_bf-f";
export var green = "_bf-c";
export var icon = "_bf-9";
export var image = "_bf-1";
export var lg = "_bf-6";
export var md = "_bf-5";
export var presenceDot = "_bf-b";
export var red = "_bf-d";
export var sm = "_bf-4";
export var status = "_bf-a";
export var typingDot = "_bf-h";
export var typingPill = "_bf-g";
export var xl = "_bf-7";
export var xs = "_bf-3";
export var xxl = "_bf-8";
export var xxs = "_bf-2";
export var yellow = "_bf-e";